import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-tribune-card-link]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-tribune-card-link]').forEach((tribuneCard) => {
    tribuneCard.addEventListener('click', (e) => tribuneCardDatalayer(e));
  });
}

function tribuneCardDatalayer(e) {
  let titleText = e.currentTarget.innerText,
    clickText = e.target.closest('[data-au-tribune-card]').querySelector('[data-au-tribune-card-quote]').innerText;

  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickCard',
    item_id,
  });
}

export default { init };
